const orderStatusEnum = Object.freeze({
    PENDING         : 1,
    CONFIRMED       : 5,
    ON_THE_WAY      : 7,
    DELIVERED       : 10,
    CANCELED        : 15,
    REJECTED        : 20,
});
export default orderStatusEnum;
